import { createStore } from 'effector';
import { useUnit } from 'effector-react';
import type { TenantBranding } from '@buildex/module-contract';
import { $bootstrapPending, $isAuthenticated } from '@buildex/core';
import { DEFAULT_BRANDING, TenantThemeProvider } from '@buildex/theme';
import { FullscreenLoader } from '@buildex/ui';
import { AdminRouter } from './router';
import { LoginPage } from '@/pages/login/LoginPage';

/** Админка платформы — нейтральный брендинг, не зависит от тенанта */
const $adminBranding = createStore<TenantBranding>(DEFAULT_BRANDING);

function AppContent() {
  const { pending, isAuthenticated } = useUnit({
    pending: $bootstrapPending,
    isAuthenticated: $isAuthenticated,
  });

  if (pending) return <FullscreenLoader />;
  if (!isAuthenticated) return <LoginPage />;
  return <AdminRouter />;
}

export function App() {
  return (
    <TenantThemeProvider branding={$adminBranding}>
      <AppContent />
    </TenantThemeProvider>
  );
}
